<template>
  <div class="login">
    <div class="top-notice" v-if="top_notice_show === 1">
      <el-button  class="top-notice-button" type="text">
        <p  class="top-notice-p" ><span style="font-weight: bold">～夜間予約受付時間変更のお知らせ～</span><br><br>

          <span style="font-weight: bold">今までは当日17:00までの受付でしたが、19:00まで受付時間を延長したことをご連絡させていただきます。</span><br>
          <span style="font-weight: bold">引き続き、変わらぬご愛顧賜りますようお願い申し上げます</span><br>
        </p><br>
        <p class="top-notice-p"><span style="font-weight: bold">昨日まで発生していましたメールの件、対応が完了致しました。</span><br>
          <span style="font-weight: bold">お客様には大変なご迷惑をお掛けしてしまい、申し訳御座いませんでした。</span><br>
          <span style="font-weight: bold">一点、***＠gmail.comでご登録されているお客様へお願いがございます</span><br>
          <span style="font-weight: bold">***＠gmail.comで登録されている場合、弊社からのメールが迷惑メールフォルダに届く可能性が御座います。</span><br>
          <span style="font-weight: bold">メールが確認出来ない場合は、お手数ですが迷惑メールフォルダをご確認ください。</span><br>
          <span style="font-weight: bold">何卒、宜しくお願い申し上げます。</span><br>
        </p>
      </el-button>
    </div>
    <div class="top-msg">
      <div class="name"><u>東港金属・本社工場</u></div>
      <el-form :model="form" :rules="rules2" ref="form" label-position="left" label-width="0" class="card-box-login-c loginform-c">
        <h3 class="title">{{systemName}}</h3>

        <el-row class="login-row">
          <el-col :span="8" class="login-label">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div class="login-integrant">必須</div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">得意先コード</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="login-input">
            <el-form-item prop="userId" >
              <el-input type="text" id = 'userId' class="login-el-input" v-model="form.userId" placeholder="得意先コードを入力してください。"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8"class="login-label">
            <el-row style="width: 140px">
              <el-col :span="24">
                <div class="login-integrant">必須</div>
              </el-col>
            </el-row>
            <el-row style="width: 140px">
              <el-col :span="24">
                <div style="">パスワード</div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 180px">指定パスワードを入力</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="login-input">
            <el-form-item prop="password">
              <el-input type="password" class="login-el-input" v-model="form.password" placeholder="指定パスワードを入力してください。"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row style="margin-top: 0.2em">
          <el-col :span="8"class="login-label">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div class="login-integrant">必須</div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 180px">処理選択</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="login-input">
            <el-row>
              <el-col :span="24" >
                <el-form-item prop="choiceRadio">
                  <el-radio-group v-model="form.choiceRadio">
                    <ul >
                      <li> <el-radio label="1" style="padding-left: 1em">搬入予定登録</el-radio></li>
                      <li> <el-radio label="0" style="padding-left: 1em">搬入状況確認</el-radio></li>
                    </ul>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row >
          <el-col :span="12">
            <el-form-item >
              <el-button type="danger" class="login-btn-left" @click.native.prevent="handleSubmit2('form')">確　認</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item >
              <el-button type="danger" class="login-btn-right" @click.native.prevent="close()">終　了</el-button>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import { isUserId } from '../../assets/js/check'
  import _g from '../../assets/js/global'

  export default {
    data() {
      var checkUserId = (rule, value, callback) => {
        if (value == null || value == '') {
          callback(new Error('得意先コードを入力してください。'))
        } else if (!isUserId(value)) {
          callback(new Error('得意先コードは9桁を入力してください。'))
        } else {
          callback()
        }
      }
      return {
        title: '',
        systemName: '夜間搬入申込サービス',
        form: {
          userId: '',
          password: '',
          choiceRadio: '1'
        },
        top_notice_show: 0,
        rules2: {
          userId: [
            { required: true, validator: checkUserId, trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'パスワードを入力してください', trigger: 'blur' }
          ],
          choiceRadio: [
            { required: true, message: '処理選択を選択してください', trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      isPDF() {
        // window.open('../../../static/file/tokometalGuidance201908.pdf')
        window.open('../../../static/file/NewyearsInfomation201912.pdf')
      },
      close() {
        document.getElementById('userId').value = ''
        var userAgent = navigator.userAgent
        if (userAgent.indexOf('Firefox') != -1 || userAgent.indexOf('Chrome') != -1) {
          window.location.href = 'about:blank'
          window.close()
        } else {
          window.opener = null
          window.open('', '_self', '')
          window.close()
        }
      },
      handleSubmit2(form) {
        var ua = window.navigator.userAgent.toLowerCase()
        if (ua.indexOf('msie') != -1 || ua.indexOf('trident/7') != -1) {
          if (window.event.which == 13) {
            return false
          }
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {}
            data.userId = this.form.userId
            data.password = this.form.password
            data.choiceRadio = this.form.choiceRadio === '1' ? 1 : 0
            this.apiPost('customer/login/login', data).then((res) => {
              this.handelResponse(res, (data) => {
                if (res.code != 200) {
                  this.handleError(res)
                } else {
                  var reData = res.data
                  window.localStorage.setItem('userId', this.form.userId)
                  window.localStorage.setItem('loginRoot', reData)
                  if (this.form.choiceRadio === '1') {
                    this.resetCommonData('/customer/informationInput')
                    _g.toastMsg('success', 'ログイン成功しました')
                  } else {
                    this.resetCommonData('/customer/search')
                    _g.toastMsg('success', 'ログイン成功しました')
                  }
                }
              })
            })
          } else {
            return false
          }
        })
      }
    },
    mounted() {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
          this.handleSubmit2('form')
        }
      })
    },
    created() {
      var sysDate = new Date()
      var month1 = (sysDate.getMonth() + 1) < 10 ? '0' + (sysDate.getMonth() + 1).toString() : (sysDate.getMonth() + 1).toString()
      var day1 = sysDate.getDate() < 10 ? '0' + sysDate.getDate().toString() : sysDate.getDate().toString()
      var hour = sysDate.getHours() < 10 ? '0' + sysDate.getHours().toString() : sysDate.getHours().toString()
      var day = sysDate.getFullYear().toString() + month1 + day1 + hour
      // console.log(day)
      if (parseInt(day) < 2024011223 && parseInt(day) >= 2021082100) {
        this.top_notice_show = 1
      }
      window.load = function() {
        document.getElementById('userId').value = ''
        // document.getElementById('password').value = ''
        // table = document.getElementById('userId')
        // rows = table.getElementsByTagName('tr')
      }
    },
    mixins: [http]
  }
</script>

<style>
  @import url("../../assets/css/common.css");

  .login-el-input{
    margin-left: 30px;
    margin: 29px 20px 0px 20px
  }
  .login-row{
    margin-bottom: 0.1em;
  }
  .login-input{
    height: 97px;
    background-color:#F5F7F7;
  }
  .login-label{
    height: 98px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .login-btn-left{
    margin-top: 1em;
    float: right;
    width: 150px;
  }
  .login-btn-right{
    margin-top: 1em;
    margin-left: 20px;
    width: 150px;
    float: left;
  }
  .card-box-login-c {
    padding: 2em;
  }
  .top-notice {
    background-color: #FFF;
    margin: 1em auto 0em;
    width: 69em;
    text-align:center;
  }
  .top-notice-button {
    text-decoration: underline;
    color: #3FCDE7;
  }
  .top-notice-p {
    font-size:20px;
    font-family: "游ゴシック Medium","Yu Gothic Medium","游ゴシック体","YuGothic","arial","helvetica","sans-serif";
  }
  .top-msg {
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 5em auto;
    width: 44em;
    border: 0.1em solid #8492A6;
  }
  .name{
    text-align: right;
    padding: 0.5em;
    font-weight: bold;
    font-size: 1.3em;
  }
  .title {
    margin: 0px auto 1em auto;
    text-align: left;
    color: #505458;
  }

  .loginform-c {
    padding: 0.1em 2em 0.1em 2em
  }
</style>
<style>
  .login .el-radio{
    margin-top: 0.8em;
    font-size: 18px;
  }
  .login .el-input{
    width: 25em
  }
  .login .el-form-item__error{
    left: 8%;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/login.vue